import { BroadcastChannel as AlternativeBroadcastChannel } from 'broadcast-channel';

export const BROADCASTCHANNEL_TYPES = {
    CLOUD_MT_USER_CHANGED: 'CLOUD_MT_USER_CHANGED',
    CLOUD_MT_COLOUR_GROUP_DELETION: 'CLOUD_MT_COLOUR_GROUP_DELETION'
};

export function SetupBroadcastChannel(broadcastChannelType) {
    let result;

    TestBroadcastChannelTypeIsValid(broadcastChannelType);

    if (typeof BroadcastChannel !== 'undefined') {
        result = new BroadcastChannel(broadcastChannelType);
    }
    else {
        result = new AlternativeBroadcastChannel(broadcastChannelType);
    }

    return result;
}

function TestBroadcastChannelTypeIsValid(broadcastChannelType) {
    if (typeof BROADCASTCHANNEL_TYPES[broadcastChannelType] == 'undefined') {
        throw `You cannot use a Broadcast Channel type of ${broadcastChannelType} as it is not defined within BROADCASTCHANNEL_TYPES.`;
    }
}
